function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3137 1H5.06275C3.98524 1 2.95186 1.42804 2.18995 2.18995C1.42804 2.95186 1 3.98524 1 5.06275V37.5647C1 38.6422 1.42804 39.6756 2.18995 40.4375C2.95186 41.1994 3.98524 41.6275 5.06275 41.6275H29.4392C30.5167 41.6275 31.5501 41.1994 32.312 40.4375C33.0739 39.6756 33.502 38.6422 33.502 37.5647V13.1882L21.3137 1Z",
  stroke: "#E6E6E6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3125 1V13.1882H33.5007",
  stroke: "#E6E6E6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.376 23.3447H9.125",
  stroke: "#E6E6E6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.376 31.4707H9.125",
  stroke: "#E6E6E6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1877 15.2197H11.1564H9.125",
  stroke: "#E6E6E6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 33.8463,
  cy: 36.3678,
  r: 12.6314,
  fill: "#111214"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M34.1867 44.6303C38.5614 44.6303 42.1078 41.0839 42.1078 36.7092C42.1078 32.3345 38.5614 28.7881 34.1867 28.7881C29.812 28.7881 26.2656 32.3345 26.2656 36.7092C26.2656 41.0839 29.812 44.6303 34.1867 44.6303Z",
  stroke: "#5779FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M34.1875 31.957V36.7097L37.3559 38.2939",
  stroke: "#5779FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDocumentWithClock(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentWithClock);
export default __webpack_public_path__ + "static/media/document-with-clock.3a3b3704d36ccfb42fa5425afc87dbe5.svg";
export { ForwardRef as ReactComponent };